// src/utils/getCollectionsPathByContext.js

/**
 * Détermine la route "Collections" correcte selon le contexte
 * - Expert → /expert/collections
 * - Collector → /collections
 *
 * Priorité :
 * 1) pathname (source de vérité si navigation déjà contextualisée)
 * 2) profile.role (fallback logique)
 *
 * @param {string} pathname - location.pathname
 * @param {object|null} profile - profile Supabase (optionnel)
 * @returns {string}
 */
export function getCollectionsPathByContext(pathname, profile) {
  // 1️⃣ Contexte URL prioritaire
  if (typeof pathname === "string") {
    if (pathname.startsWith("/expert")) {
      return "/expert/collections";
    }
  }

  // 2️⃣ Fallback par rôle
  const role = profile?.role;
  if (role === "expert") {
    return "/expert/collections";
  }

  // 3️⃣ Défaut collectionneur
  return "/collections";
}
